import clsx from "clsx";

interface ViewButtonProps {
  onClick: VoidFunction;
  open: boolean;
  className?: string;
}

export default function ViewButton({
  onClick,
  open,
  className,
}: ViewButtonProps) {
  return (
    <button
      type="button"
      className={clsx("rounded-full py-1.5 px-2 flex items-center", className)}
      onClick={onClick}
    >
      <span
        className={clsx(
          "w-5 h-5 fill-inherit",
          open
            ? "icon-[eva--arrow-ios-upward-outline]"
            : "icon-[eva--arrow-ios-downward-outline]"
        )}
        aria-hidden="true"
      ></span>
      <span className="text-sm font-medium px-2 text-inherit">View</span>
    </button>
  );
}
